import React from 'react';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import { Link } from 'react-router-dom';
import AbsoluteValue from '../../common/AbsoluteValue';
import PercentageValue from '../../common/PercentageValue';
import Tooltip from '../../common/Tooltip';
import { avgFooter, convertSumFooter } from '../../common/Datagrid/Footers';
import CountryFlag from '../../common/CountryFlag';
import ConfirmClick from '../../common/ConfirmClick';
import FilterSummary from '../mailingLists/FilterSummary';
import FilterContents from '../mailingLists/FilterContents';

var deleteSvg = require('!svg-inline-loader!../../../../public/img/icons/delete_new.svg');
var editSvg = require('!svg-inline-loader!../../../../public/img/icons/edit.svg');

export const catalogMailingListsSettings = {
	settingsForTable
};


function settingsForTable(deleteCall){
	let columns = [
	 {
		   id: 'entity_type',
		   Header: 'Catalog Type',
		   accessor: 'entity_type'
	   },      
	
	   {
		   id: 'user_filter',
		   Header: 'Filter',
		   accessor: 'user_filter',
		   Cell: props => <FilterSummary filter={props.value} />
	   },      
	   {
			  id: 'user_filter_contents',
			  Header: 'User Filter',
			  accessor: 'user_filter',
			  Cell: props => <FilterContents filter={props.value} />
		  },      

	   {
		   id: 'actions',
		   className: 'milestone-actions',
		   headerClassName: 'no-sort milestone-actions',
		   Header: 'Actions',
		   sortable: false,
		   // <a onClick={()=>setCurrentMilestone(props.original, 'showAddChannelModal')} className="btn add-to-filter"><i class="fas fa-plus"></i></a>
		   Cell: props => <div className="buttons-holder buttons-holder--milestones">
		    <Link to={`/user/catalog-report/recipients/${props.original.id}`} className="table-text-action">Recipients</Link>
				<Link to={`/user/catalog-report/${props.original.id}`} className="btn add-to-filter" title="Edit"><span className="small-icon" dangerouslySetInnerHTML={{__html: editSvg}}></span></Link>
				<ConfirmClick confirmAction={()=>deleteCall(props.original.id)} confirmClass="btn add-to-filter" confirmLabel={<span className="small-icon" dangerouslySetInnerHTML={{__html: deleteSvg}}></span>} confirmPrompt="Delete Report?" title="Delete" extraClass="dialog-modal"></ConfirmClick>
		   </div>
	   }
	   
	];
	return columns;
}
